// src/components/ui/RoleGuard.tsx
// Renders children only when the current user has at least one of the allowed roles.
// VIEWER never sees create / edit / delete buttons.

import React from 'react';
import { useAuthContext } from '../../context/AuthContext';

interface Props {
  roles: string[];          // allowed roles
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleGuard: React.FC<Props> = ({ roles, children, fallback = null }) => {
  const { hasRole } = useAuthContext();
  return roles.some(r => hasRole(r)) ? <>{children}</> : <>{fallback}</>;
};
